import type { FlagsSnapshot } from '@occc/data-flags';
import type { OpenCommerceUserCurrentQuery } from '@occc/graphql';

import { extractCommandCenter, parseFeatureFlags } from './parse-command-center';

const EMPTY: FlagsSnapshot = {};

export function selectFlags(data: OpenCommerceUserCurrentQuery | undefined): FlagsSnapshot {
  const customData = data?.openCommerceUserCurrent?.customData;
  const commandCenter = extractCommandCenter(customData);
  return commandCenter != null ? parseFeatureFlags(commandCenter) : EMPTY;
}
